export default {
  'Resolution': '分辨率',
  'Frame rate': '帧率',
  'The higher the frame rate, the smoother the animation': '帧率越高，动画越流畅。',
}